import constants from './../utils/constants';
import { firebaseFunctions } from '@/firebase';
import apiPath from './modules/apiPath';

const BOFunction = process.env.VUE_APP_FIREBASE_BO_FUNCTION || 'backoffice';

export interface Response {
  readonly headers?: any;
  readonly data: {
    code: string;
    message: string;
    data?: any;
    // eslint-disable-next-line camelcase
    outlet_info?: any;
    errCode?: number;
    invalidMessage?: string;
  };
}

export default function request(
  path: string,
  method: string,
  payload?: any,
  options?: any,
  loyaltyEngineRequest?: boolean
): Promise<Response> {
  const data = {
    path,
    method,
    options,
    payload,
    source: ''
  };
  for (const item in apiPath) {
    const element = apiPath[item];
    if (path === element.path || path.includes(element.path + '/')) {
      data.source = element.source;
    }
  }
  return new Promise((resolve, reject) => {
    firebaseFunctions
      .httpsCallable(loyaltyEngineRequest ? 'loyaltyEngine' : BOFunction)(
        data
      )
      .then(resp => {
        const responseCode = Number(resp.data.code);
        const responseData = {
          ...resp.data,
          code: String(resp.data.code),
          message: resp.data.message,
          data: resp.data.data.body,
          errCode: resp.data.data.errCode,
          invalidMessage: resp.data.data.message
        };

        if (responseCode !== constants.STATUS_200) {
          /* eslint-disable prefer-promise-reject-errors */
          reject({
            response: {
              data: responseData
            }
          });
          /* eslint-enable */
          return;
        }
        resolve({
          headers: resp.data.data.headers,
          data: responseData
        });
      }).catch((err) => {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject({
        response: {
          data: {
            invalidMessage: err.message
          }
        }
      });
    });
  });
}

export function requestGet(
  path: string,
  payload?: any,
  options?: any,
  loyaltyEngineRequest?: boolean
): Promise<Response> {
  return request(path, 'GET', payload, options, loyaltyEngineRequest);
}

export function requestPost(
  path: string,
  payload?: any,
  options?: any,
  loyaltyEngineRequest?: boolean
): Promise<Response> {
  return request(path, 'POST', payload, options, loyaltyEngineRequest);
}

export function requestPut(
  path: string,
  payload?: any,
  options?: any,
  loyaltyEngineRequest?: boolean
): Promise<Response> {
  return request(path, 'PUT', payload, options, loyaltyEngineRequest);
}

export function requestPatch(
  path: string,
  payload?: any,
  options?: any,
  loyaltyEngineRequest?: boolean
): Promise<Response> {
  return request(path, 'PATCH', payload, options, loyaltyEngineRequest);
}

export function requestDelete(
  path: string,
  payload?: any,
  options?: any,
  loyaltyEngineRequest?: boolean
): Promise<Response> {
  return request(path, 'DELETE', payload, options, loyaltyEngineRequest);
}
